import React from "react";
import {useState} from "react";
import { Form, Field } from "react-final-form";
import { Modal } from "reactstrap";

// API
import {ActivitySessionListDto} from "../../../api/models/ActivitySessionListDto";
import {ActivitySessionDateLookupDto} from "../../../api/models/ActivitySessionDateLookupDto";

// Components
import TransactionModalComponent from "./PostTransactionModal";

const VenueDetailBooking: React.FC<any> = (props: any) => {
  const [selectedSession, setSelectedSession] = useState<ActivitySessionListDto|undefined>(undefined);
  const [modal, setModal] = useState<boolean>(false);
  const unitName: string = props.venue.currentActivitySession?.unitName ? props.venue.currentActivitySession.unitName : "places";

  return (
    <div>
      <h2 className="mt-4 section_title ml-1">Reserva</h2>

      <div className="bg-white border rounded px-4 py-3 mt-3">

        {/* Dropdown to choose activity date */}
        {props.venue.chooseDateFirst && (
          <Form
            onSubmit={(values: any) => {
              var mm : number = new Date(values.date).getMonth() + 1;
              var dd : number = new Date(values.date).getDate();
              const date : string = new Date(values.date).getFullYear() + "-" + (mm > 9 ? '' : '0') + mm + "-" + (dd > 9 ? '' : '0') + dd;
              date && date !== "placeholder" && props.getSessions(props.venue.oid, date);
            }}
            render={({
              handleSubmit,
              form,
            }) => (
              <form onSubmit={handleSubmit} data-testid='form'>
                <div >
                      <div >
                        <Field
                          name="date"
                          component="select"
                          className={"form-control"}
                          data-testid='dateInput'
                          onChange={(e: any) => {
                            if (e.target.value !== "placeholder") {
                              form.change("date", new Date(e.target.value))
                              form.submit();
                            }
                          }}
                        >
                          <option value={"placeholder"}>Selecciona una data</option>
                          {props.dates.map((date: ActivitySessionDateLookupDto, i: number) => {
                            return <option value={date.date?.toString()} key={i} className={
                              date.availableTicketsCount === 0
                                ? "text-danger ml-3 dateDropdown"
                                : "text-success ml-3 dateDropdown"
                            }>
                              {date.date?.toLocaleDateString() + " - " + date.availableTicketsCount + " " + unitName + " disponibles"}
                            </option>
                          })}
                        </Field>
                      </div>
                    </div>
              </form>
            )}
          />
        )}

        {/* List of sessions */}
        <div className="list-group list-group-sesion pt-3">
          {props.sessions &&
            props.sessions.map((session: ActivitySessionListDto, i: number) => {
              return (
                <button
                  key={i}
                  type="button"
                  className="list-group-item list-group-item-action"
                  data-toggle="modal"
                  data-target="#reservaModal"
                  disabled={session.availableTicketCount === 0}
                  onClick={() => {
                    setSelectedSession(session);
                    props.getDiscounts(session.oid);
                    props.getCustomFields(session.activityOid);
                    setModal(true);
                  }}
                >
                  <b>
                    {session.activityName !== "" && !session.label && (<h6 className="blue2 mb-2">{session.activityName}</h6>)}
                    {session.label && session.activityName === "" && (<h6 className="blue2 mb-2">{session.label}</h6>)}
                    {session.label && session.activityName !== "" && (<h6 className="blue2 mb-2">{session.activityName} - {session.label}</h6>)}

                    {session?.startOnDate} {session?.startOnTime}
                    {session.endOnTime ? " a " + session.endOnTime : null}
                    <span
                      className={
                        session.availableTicketCount === 0
                          ? "text-danger ml-3"
                          : "text-success ml-3"
                      }
                    >
                      {" "}
                      {session.availableTicketCount} {unitName} disponibles
                    </span>
                  </b>
                </button>
              );
            })}
        </div>
      </div>
      
      <Modal isOpen={modal} toggle={() => setModal(!modal)}>
          <TransactionModalComponent
            {...props}
            selectedSession={selectedSession}
            modal={modal}
            setModal={setModal}
          />
      </Modal>

    </div>
  );
};

export default VenueDetailBooking;
